import React from 'react';
import styled from 'styled-components';

export default function Login() {
  return (
    <>
      <Form>
        <Label>
          Email
          <Input type="text" />
        </Label>
        <Label>
          Password
          <Input type="text" />
        </Label>
        <Row>
          <Left>
            <input type="checkbox" />Remember Me
          </Left>
          <Left>Forget Password</Left>
        </Row>
        <ButtonColumn>
          <Button>Sign In</Button>
          <ButtonTwo>Register</ButtonTwo>
          <Help>Need Help?</Help>
        </ButtonColumn>
      </Form>
    </>
  )
}
const ButtonColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
  & div:not(:first-child) {
    margin-top: 10px;
  }
`;
const Btn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  font-size: 14px;
  padding: 5px 20px;
  min-width: 100px;
  `;

const Button = styled(Btn)`
  border: 1px solid #5B0072;
  background-color: #5B0072;
  color: white;
`;

const ButtonTwo = styled(Btn)`
  border: 1px solid #BAC2CD;
  background-color: transparent;
  color: inherit;
`;

const Help = styled.div`
  font-size: 12px;
`;


const Left = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  & input {
    padding: 0;
    margin: 0 5px 0 0;
  }
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
  font-size: 11px;
`;
const Form = styled.form`
  margin-top: 30px;
  width: 200px;
  color: #48556A;
`;

const Label = styled.label`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  color: gray;
  &:first-child {
    margin-bottom: 20px;
  }
`;

const Input = styled.input`
  border: 1px solid #BAC2CD;
  border-radius: 2px;
  padding: 5px 10px;
  margin-top: 5px;
`;